import Common from '../common/CommonPowerbook';

class TmplObjectSet {

    constructor() {
        this.comm = Common.instance;
    }

     make(_d){
         return `
<section class="object object-setitem">
    <div class="object__itemlist">
        <ul>
            ${this.total(_d.part_item_list)}
        </ul>
    </div>
    <div class="object__attribute">
        사용 가능 클래스: ${_d.class.map( item => `<a href="${this.comm.powerbookURL}/${item}">${item}</a>` ).join(', ')} <br>
        세트 착용시 보너스: ${this.bonusList(_d.bonus)}
    </div>
</section>`;
     }

    total(_d){
        let list = _d.map( item =>{
            return `
<li>
    <img class="object__icon" src="${this.comm.staticImgURL}/powerbook/lineage/${item.image}" alt="">
    <span class="object__name"><a class="item-grade--${item.grade}" href="${this.comm.powerbookURL}/${item.name}">${item.name}</a></span>
</li>`
        } ).join(' ');
        return list;
    }

    bonusList(_d){
        if(!_d) return '';
        let list = _d;

        let optionList = list.map( (item) =>{
            let arr = /([^뷁]+)([-|+][0-9]+)/g.exec(item);
            let strA = (!!arr && !!arr.length)? arr[1]: item;
            let strB = (!!arr && !!arr.length)? arr[2]: '';

            return `<a href="${this.comm.powerbookURL}/${strA}">${strA}</a>${strB}`;
        } ).join(', ');
        return optionList;
    }


}
export default TmplObjectSet;




// WEBPACK FOOTER //
// ./lineage/TmplObjectSet.js